import { Component } from "@angular/core";
import { Assurance } from "../core/model/assurance";
import { AssuranceService } from "../core/service/assurance.service";
import { EditAssuranceComponent } from "./edit-assurance/edit-assurance.component";
import { AddAssuranceComponent } from "./add-assurance/add-assurance.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-assurance",
  templateUrl: "./assurance.component.html",
  styleUrls: ["./assurance.component.scss"],
})
export class AssuranceComponent {
  assurances: Assurance[];

  constructor(
    private modalService: NgbModal,
    private _assuranceService: AssuranceService
  ) {}

  ngOnInit() {
    this.getAssurances();
  }

  getAssurances() {
    this._assuranceService.getAllAssurances().subscribe(
      (data) => {
        this.assurances = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  edit(assurance: Assurance): void {
    const modalRef = this.modalService.open(EditAssuranceComponent, {
      centered: true,
    });
    modalRef.componentInstance.assurance = assurance;

    modalRef.result.then(
      (updated: Assurance) => {
        if (updated && this.assurances) {
          const index = this.assurances.findIndex((a) => a.id === updated.id);
          if (index !== -1) {
            this.assurances[index] = updated;
            this.assurances = [...this.assurances];
            return;
          }
        }
        this.getAssurances();
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  add(): void {
    const modalRef = this.modalService.open(AddAssuranceComponent, {
      centered: true,
    });

    modalRef.result.then(
      (data) => {
        // on close
        this.getAssurances();
      },
      (reason) => {
        // on dismiss
      }
    );
  }
}
